export default "__VITE_ASSET__GvFfztRL__"